<template>
  <v-container class="bg-white">
    <v-btn
      prepend-icon="mdi-arrow-left"
      @click="router.back()"
      >Zurück</v-btn
    >
    <v-card
      class="pa-5"
      variant="text">
      <v-card-title>Eigene Lizenz bearbeiten</v-card-title>
      <v-card-text>
        <v-row v-if="paymentInformation.brand">
          <v-col cols="6"> Zahlungsart </v-col>
          <v-col cols="6"> {{ paymentInformation.brand }} </v-col>
          <v-col cols="6"> Letzte 4 Ziffern </v-col>
          <v-col cols="6"> {{ paymentInformation.last4 }} </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
      </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <template v-if="current_status !== 'paid'">
      <v-alert
        color="error"
        :dismissible="false">
        <span>{{ $t("views.licence.other.not-paid") }}</span>
        <v-spacer></v-spacer>
        <v-btn
          style="color: black"
          v-if="current_status !== 'draft'"
          @click="payNow">
          {{ $t("views.licence.other.pay-now") }}
        </v-btn>
      </v-alert>
    </template>
    <div :class="current_status !== 'paid' ? 'disabled-change-module' : ''">
      <ModuleListPrivate
        ref="moduleList"
        v-if="loaded"
        :model-value="modules"
        :current_phase="current_phase"
        :current_phase_mode="current_phase_mode"
        :next_phase="next_phase"
        :save="updateModules"
        :saving="saving"
        :current_status="current_status"
        :licenceId="licence_id" v-model:mode="paymentMode" :next_billing_cycle_anchor="next_billing_cycle_anchor" />
    </div>
    <v-dialog v-model="addressDialog">
      <InvoiceAdressView :success="finalizeUpdate" />
    </v-dialog>
  </v-container>
</template>

<script lang="ts" setup>
import { useSpaceStore } from "@/stores/spaceStore";
import axios from "axios";
import { useTranslation } from "i18next-vue";
import { onMounted, useTemplateRef } from "vue";
import { computed } from "vue";
import { ref } from "vue";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { SPACE_RIGHT_WRITE, spaceRightNames } from "@/utils/constants";
import { useMainStore } from "@/stores/mainStore";
import { useAuthStore } from "@/stores/authStore";
import { SPACE_RIGHT_READ, MODULES } from "@/utils/constants";
import ModuleListPrivate from "./Licence/ModuleListPrivate.vue";
import { useRouter } from "vue-router";
import InvoiceAdressView from "@/components/dialogs/InvoiceAdressView.vue";
import { useSocketStore } from "@/stores/socketStore";

const mainStore = useMainStore();
const authStore = useAuthStore();
const socketStore = useSocketStore();

const moduleList = useTemplateRef("moduleList");

const router = useRouter();

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const addressDialog = ref(false);

const emits = defineEmits(["close"]);

const modules = ref({});
const current_status = ref("paid");
const licence_id = ref();
const loaded = ref(false);
const paymentMode = ref("monthly");

const next_phase = ref({});
const next_phase_mode = ref("");
const current_phase = ref({});
const current_phase_mode = ref("");

const next_billing_cycle_anchor = ref<null|number>(null)

const paymentInformation = ref({
  last4: "",
  brand: ""
});

const saving = ref(false);

socketStore.socket.on("payment-change", () => {
  console.log("payment-change Licence Private");
  loadModules();
});

onMounted(() => {
  loadModules();
});

function loadModules() {
  loaded.value = false;
  axios.get("/api/licence/private").then((response) => {
    console.log(response.data);

    // modules.value = formatModules(response?.data?.modules);
    // allModules.value = formatModules(response?.data?.allModules);
    next_phase.value = formatModules(response?.data?.next_phase);
    next_phase_mode.value = response?.data?.next_phase_mode;
    modules.value = formatModules(response?.data?.next_phase);
    current_phase.value = formatModules(response?.data?.current_phase);
    current_phase_mode.value = response?.data?.current_phase_mode;
    current_status.value = response?.data?.current_status;
    licence_id.value = response?.data?.licence_id;
    next_billing_cycle_anchor.value = response.data.next_billing_cycle_anchor
    // newModules.value = formatModules(response?.data?.newModules);
    loaded.value = true;
    licence_id.value && loadPaymentInformation();
    paymentMode.value = next_phase_mode.value;
  });
}

function loadPaymentInformation() {
  axios
    .get("/api/stripe/payment-information/" + licence_id.value)
    .then((response) => {
      console.log(response.data);
      paymentInformation.value = response.data.card;
    })
    .catch((err) => console.log);
}

function formatModules(
  modules: Record<string, number>
): Record<number, number> {
  console.log("Hier", modules);
  return Object.fromEntries(
    mainStore.modules.map((module) => [module.value, modules[module.name]])
  );
}

const byName = computed(() => {
  return Object.fromEntries(
    mainStore.modules.map((module) => [
      module.name,
      modules.value[module.value]
    ])
  );
});

function updateModules() {
  if (!authStore.user.stripe) {
    addressDialog.value = true;
  } else {
    finalizeUpdate();
  }
}

function finalizeUpdate() {
  addressDialog.value = false;
  saving.value = true;
  axios
    .post("/api/licence/private", { modules: byName.value, paymentMode: paymentMode.value })
    .then((x) => {
      console.log(x);
      // mainStore.loadCalculationSpaces();
      // router.back();
      saving.value = false;
      open(x.data, "_self");
    })
    .catch((x) => {
      saving.value = false;
      console.log(x);
    });
}

function payNow() {
  if (current_status.value === null) {
    moduleList.value.saveModules(updateModules);
  } else {
    axios
      .get("/api/stripe/latest-invoice/" + licence_id.value)
      .then((response) => {
        console.log("Success", response.data);
        window.open(response.data.hosted_invoice_url, "_blank");
      });
  }
}
</script>

<style>
.disabled-change-module {
  opacity: 0.7;
  pointer-events: none;
}
</style>
